import { render, staticRenderFns } from "./SjGoods.vue?vue&type=template&id=26019542&scoped=true"
import script from "./SjGoods.vue?vue&type=script&lang=js"
export * from "./SjGoods.vue?vue&type=script&lang=js"
import style0 from "./SjGoods.vue?vue&type=style&index=0&id=26019542&prod&lang=css"
import style1 from "./SjGoods.vue?vue&type=style&index=1&id=26019542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26019542",
  null
  
)

export default component.exports